import { render, staticRenderFns } from "./assign-by-email.vue?vue&type=template&id=825d231a&scoped=true&"
import script from "./assign-by-email.vue?vue&type=script&lang=js&"
export * from "./assign-by-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825d231a",
  null
  
)

export default component.exports